/* Guide article: table of contents, reading progress, copy link. */
(function () {
  var root = document.querySelector('[data-pq-article]');
  if (!root) return;
  var content = root.querySelector('.blog-post-content');
  var heads = content ? Array.prototype.slice.call(content.querySelectorAll('h2')) : [];

  /* ---- TOC ---- */
  if (heads.length >= 2) {
    var used = {};
    var items = heads.map(function (h) {
      var id = h.id || h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (used[id]) id += '-' + (++used[id]); else used[id] = 1;
      h.id = id;
      return { id: id, text: h.textContent.trim(), el: h };
    });
    root.querySelectorAll('[data-pq-toc-list]').forEach(function (ol) {
      ol.innerHTML = items.map(function (i) {
        return '<li><a href="#' + i.id + '">' + i.text.replace(/</g, '&lt;') + '</a></li>';
      }).join('');
      var box = ol.closest('[data-pq-toc], [data-pq-toc-inline]');
      if (box) box.hidden = false;
    });
    var rail = root.querySelector('[data-pq-toc]');
    if (rail && 'IntersectionObserver' in window) {
      var links = {};
      rail.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
      var current = null;
      var setActive = function (id) {
        if (current === id) return;
        current = id;
        Object.keys(links).forEach(function (k) { links[k].classList.toggle('is-active', k === id); });
      };
      var positions = function () {
        var y = window.scrollY + 140, active = items[0].id;
        for (var i = 0; i < items.length; i++) { if (items[i].el.offsetTop <= y) active = items[i].id; }
        setActive(active);
      };
      window.addEventListener('scroll', positions, { passive: true });
      positions();
    }
    root.querySelectorAll('.pq-toc a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        e.stopPropagation();
        var head = document.querySelector('.shopify-section-group-header-group, header.pq-head');
        var off = (head ? head.getBoundingClientRect().height : 76) + 24;
        var top = t.getBoundingClientRect().top + window.scrollY - off;
        window.scrollTo({ top: top, behavior: 'smooth' });
        try { history.replaceState(null, '', '#' + t.id); } catch (err) {}
        var d = a.closest('details'); if (d) d.open = false;
      }, true);
    });
  }

  /* ---- progress ---- */
  var bar = document.querySelector('[data-pq-progress]');
  if (bar && content) {
    var tick = function () {
      var top = content.getBoundingClientRect().top + window.scrollY;
      var h = content.offsetHeight - window.innerHeight * 0.6;
      var p = h > 0 ? Math.min(1, Math.max(0, (window.scrollY - top + 120) / h)) : 1;
      bar.style.transform = 'scaleX(' + p + ')';
    };
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  /* ---- copy link ---- */
  root.querySelectorAll('[data-pq-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-pq-copy');
      var done = function () {
        var s = btn.querySelector('.pq-article__copied');
        btn.classList.add('is-done');
        if (s) s.textContent = 'Link copied';
        setTimeout(function () { btn.classList.remove('is-done'); if (s) s.textContent = ''; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
      else { var i = document.createElement('input'); i.value = url; document.body.appendChild(i); i.select(); try { document.execCommand('copy'); } catch (e) {} i.remove(); done(); }
    });
  });
})();
